<div nz-row class="customer-request-image"></div>
<div class="customer-request">
  <div class="customer-message">
    <div class="content">
      <div style="font-weight: bold; padding-bottom: 5px; font-size: 28px;">
        구매 문의<br />
      </div>
      <div style="font-weight: normal; font-size: 18px;">
        <p>
          문의를 남겨주시면 빠른 시일내에 답장 드리겠습니다.<br />
        </p>
      </div>
    </div>
  </div>
  <nz-layout class="customer-request-container">
    <nz-content>
      <nz-row>
        <div nz-col nzFlex="70px" class="request-title">성명</div>
        <div nz-col nzFlex="auto">
          <input nz-input [(ngModel)]="userName"
            [ngClass]="userName.length === 0? 'value-error' : ''"
            (ngModelChange)="valueChanged()"/>
        </div>
      </nz-row>
      <nz-row>
        <div nz-col nzFlex="70px" class="request-title">E-mail</div>
        <div nz-col nzFlex="auto">
          <input nz-input
            [(ngModel)]="email"
            [ngClass]="email.length === 0? 'value-error' : ''"
            (ngModelChange)="valueChanged()"/>
        </div>
      </nz-row>
      <nz-row>
        <div nz-col nzFlex="70px" class="request-title">전화번호</div>
        <div nz-col nzFlex="auto">
          <input nz-input [(ngModel)]="phoneNumber"/>
        </div>
      </nz-row>
      <nz-row>
        <div nz-col nzFlex="70px" class="request-title">문의부서</div>
        <div nz-col nzFlex="auto">
          <nz-select style="width: 130px;" [(ngModel)]="productType">
            <nz-option nzValue="semi" nzLabel="반도체사업부"></nz-option>
            <nz-option nzValue="md" nzLabel="판금사업부"></nz-option>
          </nz-select>
        </div>
      </nz-row>
      <nz-row>
        <div nz-col style="width: 70px; float:left; font-weight: bold;">내용</div>
        <div nz-col style="float: left;">
          <textarea nz-input rows="5" style="width: 600px;"
            [(ngModel)]="description"></textarea>
        </div>
      </nz-row>
      <nz-row style="float: right;">
        <button nz-button nzType="primary" (click)="request()" [disabled]="isInValidRequest">문의하기</button>
      </nz-row>
      <div style="height: 150px;"></div>
    </nz-content>
  </nz-layout>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br />
    [SEOUL] T 02-2115-8815 F 02-2115-8818 [CHEON-AN] T 041-582-2214, 2215 F 041-588-2215</p>
</div>
